import config from 'config';

export const selfieSegmentationCdnUrl = config.webgl.selfieSegmentationUrl;
export const framerate = 1000 / 30;
export const initTimer = 33;
